import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles.scss';
const ServiceNameFieldDescription = () => (
  <ul className={styles.oversizedLiItem}>
    <li>
      <FormattedMessage id={'forms.general.serviceNameDescription1'} />
    </li>
    <li>
      <FormattedMessage id={'forms.general.serviceNameDescription2'} />
    </li>
  </ul>
);

export default ServiceNameFieldDescription;
